import React, { useState } from 'react';
import UploadIcon from 'src/common/utils/TableColumnIcons/UploadIcon';
import CheckIcon from 'src/common/utils/TableColumnIcons/CheckIcon';
import CloseIcon from 'src/common/utils/TableColumnIcons/CloseIcon';
import DownloadIcon from 'src/common/utils/TableColumnIcons/DownloadIcon';
import { UploadFileMinos, download } from 'src/pages/Files/UpaloadFileMinos';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import notice from 'src/common/components/Notice';
import { filesAPI } from 'src/api/modules/files';

export const FileColumn = ({
	onClickAcept,
	onClickrechazar,
	value,
	row,
	rowIndex,
	currentIcon,
	onUpload,
	nameSesion,
	btnFlag = null,
	setFlagRender = false,
}) => {
	let { dataMinos, perfil, userName } = row;
	let currentdataMinos = dataMinos[currentIcon];
	currentdataMinos['organo'] = row.organo !== undefined ? row.organo : row.organoId;
	currentdataMinos['resolucion'] = row.numeroResolucion;
	currentdataMinos['tema'] = row.tema;
	const [nombreFile, setNombreFile] = useState(currentdataMinos.nombre);
	const estatus = currentdataMinos.estatus;
	const [open, setOpen] = useState(false);
	let logRes = 'resolución/recomendación ' + currentdataMinos.resolucion;
	let logTopic =
		'Inclusión de Tema: ' + currentdataMinos.tema + ', de la sesión ' + nameSesion;

	const handlerSetName = (name) => {
		setNombreFile(name);
		if (onUpload) onUpload(currentdataMinos, rowIndex);
		if (setFlagRender !== false) setFlagRender(true);
	};
	const getId = () => {
		return (
			'BtnuploadMinos' +
			currentdataMinos.idEntidad.toString() +
			currentdataMinos.title.replaceAll(' ', '')
		);
	};
	const _onClickAcept = (currentdataMinos) => {
		onClickAcept(currentdataMinos, rowIndex, currentIcon);
	};

	const getColorByStatus = () => {
		if (estatus === 'R' || estatus === 'RR') {
			let coloreMes = 'red';
			return coloreMes;
		}
		if (estatus === 'A' || estatus === 'APO') return 'green';
		return '';
	};
	const nameFile = (data) => {
		setNombreFile(data.nombre);
	};

	const onDelete = (ruta) => {
		filesAPI
			.deleteFiles(ruta.id)
			.then((response) => {
				notice('Archivo Eliminado con Exito', 'success');
				if (onUpload) onUpload(currentdataMinos, rowIndex);
				if (setFlagRender !== false) setFlagRender(true);
			})
			.catch((e) => {
				notice('Ha ocurrido un error al eliminar el archivo');
			})
			.finally(() => {});
	};

	const downloadMigrated = (file) => {
		filesAPI
			.DownloadFilesMigrated(file.idMigrado, file.versionArchivo)
			.then((response) => {
				let blob = response;
				let da = document.createElement('a');
				da.href = URL.createObjectURL(blob);
				da.setAttribute('download', file.nombre);
				da.click();
				URL.revokeObjectURL(da.href);
				notice('Se descargo el archivo con éxito', 'success');
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'error');
			});
	};

	return (
		<>
			{btnFlag === null &&
				(perfil.toUpperCase() === 'ENLACE' &&
				estatus !== 'APO' &&
				estatus !== 'A' ? (
					<UploadFileMinos
						onSetName={handlerSetName}
						control={
							<UploadIcon
								onClick="download"
								download="download"
								name="nameFile"
								id={getId()}
								color="#808080"
							/>
						}
						idEntidad={currentdataMinos.idEntidad}
						tipo={currentdataMinos.tipo}
						entidad={currentdataMinos.entidad}
						ruta={currentdataMinos.ruta}
						title={currentdataMinos.title}
						nombre={nombreFile}
						onUploaded={nameFile}
						setOpen={setOpen}
					/>
				) : (
					<div></div>
				))}
			{btnFlag !== null &&
				btnFlag === false &&
				(perfil.toUpperCase() === 'ENLACE' &&
				estatus !== 'APO' &&
				estatus !== 'A' ? (
					<UploadFileMinos
						onSetName={handlerSetName}
						control={
							<UploadIcon
								onClick="download"
								download="download"
								name="nameFile"
								id={getId()}
								color="#808080"
							/>
						}
						idEntidad={currentdataMinos.idEntidad}
						tipo={currentdataMinos.tipo}
						entidad={currentdataMinos.entidad}
						ruta={currentdataMinos.ruta}
						title={currentdataMinos.title}
						nombre={nombreFile}
						onUploaded={nameFile}
						setOpen={setOpen}
					/>
				) : (
					<div></div>
				))}
			{
				<Backdrop open={open} style={{ zIndex: 1 }}>
					<CircularProgress color="secondary" />
				</Backdrop>
			}
			{nombreFile !== '' ? (
				<DownloadIcon
					colorName={getColorByStatus()}
					tooltip={`${nombreFile} - ${currentdataMinos.message}`}
					onClick={() =>
						currentdataMinos.isMigrated
							? downloadMigrated(currentdataMinos)
							: download(
									currentdataMinos.ruta,
									nombreFile,
									userName,
									setOpen,
									currentdataMinos.tema !== undefined
										? logTopic
										: logRes
							  )
					}
				/>
			) : (
				<div></div>
			)}
			{(perfil.toUpperCase() !== 'SISTEMA' &&
				perfil.toUpperCase() !== 'RESPONSABLE DE NEGOCIO' &&
				perfil.toUpperCase() !== 'ADMINISTRADOR GENERAL' &&
				perfil.toUpperCase() !== 'RESPONSABLE DE ORGANO COLEGIADO' &&
				perfil.toUpperCase() !== 'RESPONSABLE DE SEGUIMIENTO') ||
			currentdataMinos.nombre === '' ? (
				<div></div>
			) : estatus === 'A' ||
			  (perfil.toUpperCase() === 'RESPONSABLE DE SEGUIMIENTO' &&
					estatus === 'APO') ? (
				<span style={{ color: 'green' }}>
					<CheckIcon tooltip={nombreFile + ' - Aceptado'} color="success" />
				</span>
			) : (
				<>
					<CheckIcon
						onClick={() => _onClickAcept(currentdataMinos)}
						colorName={getColorByStatus()}
						className={currentdataMinos.isMigrated ? 'd-none' : ''}
					/>
					<CloseIcon
						onClick={() => onClickrechazar(currentdataMinos)}
						colorName={getColorByStatus()}
						className={currentdataMinos.isMigrated ? 'd-none' : ''}
					/>
				</>
			)}
			<div
				style={{
					display: 'flex',
					gap: '2px',
					maxWidth: '110px',
					alignItems: 'center',
					margin: '0 auto',
					justifyContent: 'center ',
				}}
			>
				{(currentdataMinos.estatus === 'R' ||
					currentdataMinos.estatus === 'RR') &&
					perfil.toUpperCase() === 'ENLACE' && (
						<Delete
							cursor={'pointer'}
							onClick={() => onDelete(currentdataMinos)}
						/>
					)}
				{btnFlag === null
					? perfil.toUpperCase() === 'ENLACE' &&
					  estatus !== 'A' &&
					  estatus !== 'APO' &&
					  estatus !== '' && (
							<Delete
								cursor={'pointer'}
								onClick={() => onDelete(currentdataMinos)}
							/>
					  )
					: perfil.toUpperCase() === 'ENLACE' &&
					  estatus !== 'A' &&
					  estatus !== 'APO' &&
					  estatus !== '' &&
					  btnFlag === false && (
							<Delete
								cursor={'pointer'}
								onClick={() => onDelete(currentdataMinos)}
							/>
					  )}
			</div>
		</>
	);
};
